import React from "react";
import { Link } from "../../raw-components/link/link";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { DepositSideMenuLinkBox } from "./boxes/link/deposit-side-menu-link.box";
import { GenericSideMenuLabelBox } from "./boxes/link/generic-side-menu-label.box";
import { ArrowSideMenuLinkIcon } from "./icons/arrow-side-menu-link.icon";
import { SideMenuLinkProps } from "../side-menu-link.interface";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";

export class DepositSideMenuLink extends OrbitComponent<SideMenuLinkProps> {
    render() {
        const config = this.props.config;
        const href = this.services.location.buildFullUri(config.link);
        return <Link href={decodeURI(encodeURI(href.toString()))} onClick={this.onClick}>
            <DepositSideMenuLinkBox>
                <GenericSideMenuLabelBox>{ this.services.translation.translate(config.text) }</GenericSideMenuLabelBox>
                <ArrowSideMenuLinkIcon />
            </DepositSideMenuLinkBox>
        </Link>;
    }
    onClick = async () => {
        const config = this.props.config;
        this.services.analytics.sendOrbitUserFlowEvent("Navigation","NavBar", config.text);
        this.services.sideMenu.closeMobileMenu();
        await this.services.cashier.openDeposit({
            channel: {
                source: CHANNEL_SOURCE.casinoClient,
                area: AreaType.NavigationMenu,
                element: CHANNEL_ELEMENTS.depositButton
            }
        });

        // run whatever else was passed by props
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
}
